import { render, staticRenderFns } from "./BaseState.vue?vue&type=template&id=6e9b527a&scoped=true&"
import script from "./BaseState.vue?vue&type=script&lang=ts&"
export * from "./BaseState.vue?vue&type=script&lang=ts&"
import style0 from "./BaseState.vue?vue&type=style&index=0&id=6e9b527a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9b527a",
  null
  
)

export default component.exports